import React from "react";
import PropTypes from "prop-types";

import { Field, Control, Label, Input } from "rbx";
import { BooleanInput } from "../inputs";
import SystemCodeCategorySelect from "./SystemCodeCategorySelect";
import SystemCodeNameSelect from "./SystemCodeNameSelect";

const SystemCodeForm = ({ inputs, onChange, where }) => (
  <React.Fragment>
    <Field className="grid-override is-three" kind="group">
      <Control expanded>
        <Label>Category</Label>
        <SystemCodeCategorySelect
          required
          icon="globe"
          label="Select..."
          name="Category"
          orderByMulti={["Category_ASC"]}
          value={inputs.Category}
          where={where}
          onChange={onChange}
        />
      </Control>
      <Control expanded>
        <Label>Code Name</Label>
        <SystemCodeNameSelect
          required
          category={inputs.Category}
          icon="globe"
          label="Select..."
          name="CodeName"
          orderByMulti={["CodeName_ASC"]}
          value={inputs.CodeName}
          where={
            where?.Category_in && inputs.Category === "Inventory"
              ? { Category: inputs.Category, CodeName: "InspectionCd" }
              : { Category: inputs.Category }
          }
          onChange={onChange}
        />
      </Control>
      <Field kind="group">
        <Control expanded>
          <Label>Code Id</Label>
          <Input
            required
            autocomplete="new"
            name="CodeId"
            type="text"
            value={inputs.CodeId}
            onChange={onChange}
          />
        </Control>
        <Control>
          <Label>Active</Label>
          <BooleanInput
            name="Active"
            value={inputs.Active}
            onChange={onChange}
          />
        </Control>
      </Field>
    </Field>
    <Field className="grid-override" kind="group">
      <Control expanded>
        <Label>Code Description</Label>
        <Input
          required
          autocomplete="new"
          name="CodeDescription"
          type="text"
          value={inputs.CodeDescription}
          onChange={onChange}
        />
      </Control>
      <Control expanded>
        <Label>List Order</Label>
        <Input
          autocomplete="new"
          name="ListOrder"
          type="number"
          value={inputs.ListOrder}
          onChange={onChange}
        />
      </Control>
    </Field>
  </React.Fragment>
);

SystemCodeForm.propTypes = {
  inputs: PropTypes.object,
  onChange: PropTypes.func,
  where: PropTypes.object
};
export default SystemCodeForm;
